var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dyhBasetable',{ref:"dyhBaseTableRef",attrs:{"who":'allvip',"column":_vm.underinfoColumn,"bs_place":'请输入会员名，会员卡号查询'},on:{"reflashTable":_vm.OfflineGetBaseInfoList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }